import {
  GraphQLInputObjectType,
  GraphQLNonNull,
  GraphQLID,
  GraphQLBoolean
} from 'graphql'
import { ServerFilterArgType, ServerFilterArg } from './server-filter-arg'

export interface ServerFilterDeleteMutationArgs {
  readonly input?: {
    readonly organizationID: string
    readonly filters: ServerFilterArg
    readonly deleteVulnerabilities: boolean
  }
}

export const serverFilterDeleteMutationArgs = {
  input: {
    type: new GraphQLInputObjectType({
      name: 'ServerFilterDeleteMutationArgs',
      description:
        'Mutation input type for deleting servers based on a set of filters.',
      fields: () => ({
        organizationID: {
          description:
            'The ID of the organization that owns the servers being mutated.',
          type: new GraphQLNonNull(GraphQLID)
        },
        filters: {
          description:
            'A collection of filters to specify which servers the mutation should apply to.',
          type: new GraphQLNonNull(ServerFilterArgType)
        },
        deleteVulnerabilities: {
          description:
            'Whether or not to delete the vulnerabilities found on this server.',
          type: new GraphQLNonNull(GraphQLBoolean)
        }
      })
    })
  }
}
